import uiRouter from 'angular-ui-router';
import { faqsDirective } from './faqs.directive';
import { faqsStore } from './faqs.store';

export const faqs = angular
  .module('faqs', [uiRouter])
  .config($stateProvider => {
    $stateProvider.state('app.faqs', {
      url: '/CustFAQ.aspx',
      template: '<faqs></faqs>',
      data: {
        metaTitle: 'Rentaskip Australia | FAQ about skip hire',
        metaDescription:
          'FAQ page - Frequently asked questions about skip bin hire, sizes, waste types and payment options',
        metaKeywords: 'Skip bin hire, FAQ'
      }
    });
  })
  .directive('faqs', faqsDirective)
  .factory('faqsStore', faqsStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/faqs/faqs.js
 **/